import AddInspectionDialog from './AddInspectionDialog.container';
export default AddInspectionDialog;
